import 'url-search-params-polyfill';
import CustomSelect from '../form/custom-select';
import MortgageUtils from './utils';
import Observer from '../../common/scripts/observer';
import RangeSlider from '../../components/range-slider';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();
const U = new MortgageUtils();

// j-mortgage-program
class MortgageCalculator {
    constructor(options) {
        this.wrapper = options.wrapper;
        this.programRateSelector = '.j-mortgage-calculator__rate';
        this.programMountlyPaymentSelector = '.j-mortgage-calculator__payment';
        this.programFirstPaymentSelector = '.j-mortgage-calculator__first-payment';
        this.programLimitationSelector = '.j-mortgage-calculator__limitation';
        this.disabledClass = 'is-disabled';
        this.hiddenClass = 'is-hidden';
        this.rangeSliders = [];
        this.activeProgram = null;

        this._setInitialElements();
    }

    /**
     * Метод находит необходимые DOM-элементы для работы калькуляторы
     */
    _setInitialElements() {
        this.sliders = [...this.wrapper.querySelectorAll('.j-range-slider')] || null;
        this.result = this.wrapper.querySelector('.j-mortgage-calculator__mortgage') || null;
        this.programResult = this.wrapper.querySelector('.j-mortgage-calculator__programs-result') || null;
        this.programNoResult = this.wrapper.querySelector('.j-mortgage-calculator__programs-no-result') || null;
        this.programs = [...this.wrapper.querySelectorAll('.j-mortgage-calculator__program')] || null;
        this.mortgagePercent = this.wrapper.querySelector('.j-range-slider__percent') || null;
        this.resetFilters = this.wrapper.querySelector('.j-mortgage-calculator__reset') || null;
        this.selectProgramWrapper = this.wrapper.querySelector('.j-mortgage-program');
        this.priceWrapper = this.wrapper.querySelector('.j-mortgage-price');
        this.price = Number(this.priceWrapper.textContent.replace(/\s+/g, ''));
        this.form = this.wrapper.querySelector('.j-mortgage-calculator__filter');
    }

    /**
     * Метод иницализирует модуль
     */
    init() {
        this._subscribes();
        this._initCalcSliders();
        this._initSelects();
        this._bindEvents();
        this.setShareParam(false);
    }

    /**
     * Инициализайия слайдеров ипотечного калькулятора
     * @private
     */
    _initCalcSliders() {
        if (this.sliders.length) {
            this.sliders.forEach((slider) => {
                this._initSlider(slider);
            });
        }
    }

    _initSlider(slider) {
        const rangeSlider = new RangeSlider();

        rangeSlider.init({
            wrapper: slider,
            name   : slider.dataset.slider
        });

        this.rangeSliders.push(rangeSlider);
    }

    /**
     * Инициализация селектов
     * @private
     */
    _initSelects() {
        if (!this.selectProgramWrapper) {
            return;
        }

        this.selectProgram = new CustomSelect({
            elem: this.selectProgramWrapper
        });

        this.selectProgram.init();

        this._bindEventsSelect();
    }

    _bindEvents() {
        if (this.resetFilters) {
            this.resetFilters.addEventListener('click', () => {
                this._resetData();
            });
        }
    }

    /**
     * Навешивает обработчик событий на селект с программами
     * @private
     */
    _bindEventsSelect() {
        if (!this.selectProgram) {
            return;
        }

        this.selectProgramWrapper.addEventListener('change', () => {
            this._updateActiveProgram();
            // const isProgram = this.selectProgram.getOptions()
            //     .find((program) => {
            //         return program.checked;
            //     });

            // this.activeProgram = isProgram && isProgram.value !== 'all' ? isProgram.value : null;

            this.update();
        });
    }


    /**
     * Метод содержит в себе колбэки на событиях других модулей
     * @private
     */
    _subscribes() {
        observer.subscribe('rangeSliderStart', (data, rangeSlider) => {
            data.input = rangeSlider.wrapper.querySelector('input');
            data.rangeSlider = rangeSlider;
            if (rangeSlider.name === 'price') {
                this._updatePrice(data.from, rangeSlider.price);
            }

            this.updateSlidersValues(data, null);
            this.manualInput(data, this);
            this.update();
        });

        observer.subscribe('rangeSliderChange', (data, name) => {
            if (name === 'price') {
                this._updatePrice(data.from, data.rangeSlider.price);
            }

            this.updateSlidersValues(data, 'set');
            this.update();
        });

        observer.subscribe('rangeSliderFinish', (data, name) => {
            if (name === 'price') {
                this._updatePrice(data.from, data.rangeSlider.price);
            }

            this.setCredit();
            this.setShareParam();
        });

        observer.subscribe('popup-constructor:saveMortgage', (price) => {
            this.price = price;
            this.setCredit();
        });
    }

    _resetData() {
        // Сбрасываем форму
        this.form.reset();

        // Сбрасываем значения слайдеров
        this.rangeSliders.forEach((rangeSlider) => {
            rangeSlider.reset();
        });

        // Устанавливаем активную программу в данных скрипта для расчета
        this._updateActiveProgram();

        // Обновляем селект
        this.selectProgram.update();

        this.update();

        window.history.pushState(null, null, window.location.pathname);
    }

    /**
     * Устаналвивает активную программу
     */
    _updateActiveProgram() {
        const isProgram = this.selectProgram.getOptions()
            .find((program) => {
                return program.checked;
            });

        this.activeProgram = isProgram && isProgram.value !== 'all' ? isProgram.value : null;
    }

    /**
     * Обновление значений экземпляра слайдера и запись в хранилище сессии при необходимости
     * @param {Object} data - данные слайдеров
     * @param {String/Null} flag - флаг, показывающий, нужно ли записывать данные слайдеров в хранилище сессии
     */
    updateSlidersValues(data, flag = null) {
        this.updateData(data, flag);
        MortgageCalculator.setInput(data.from, data);
        this.setCredit();
    }

    /**
     * Считываем из хранилища или записываем в хранилище данные о текущем положении ползунков
     * @param {Object} data - все значения слайдера
     * @param {String} flag - флаг, указывающий, что данные нужно записать в хранилище
     */
    updateData(data, flag) {
        const key = U.getObjectData(data).key;

        const isDisabled = data.input.disabled;

        if (parseInt(Utils.getUrlParams(key)) && flag !== 'set' && !isDisabled) {
            data.from = parseInt(Utils.getUrlParams(key));
            U.accessStorage(key, data.from);
        } else {
            data.from = parseInt(data.from);
            U.accessStorage(key, data.from);
        }
    }

    _updatePrice(from, priceEl) {
        this.price = from;
        priceEl.innerText = Utils.convertToDigit(this.price);
    }

    /**
     * Записываем в инпуты значения слайдеров.
     * Добавляем разрядные пробелы и постфикс для срока кредита
     * @param {Object} value - значение слайдера
     * @param {Object} data - параметры слайдера
     */
    static setInput(value, data) {
        data.input.value = value.toLocaleString('ru-Ru');
    }

    /**
     * Выводим сумму и процент кредита
     * Если процент больше 100, выделяем его красным, а сумму кредита не выводим
     */
    setCredit() {
        this.mortgagePercent.innerHTML = U.calcCredit(this.price).percent;
    }

    /**
     * Метод для непосредственного взаимодействия с инпутами (без использования слайдеров)
     * @param {Object} data - все значения слайдера
     * @param {Object} obj - экземпляр HTB для текущего инпута
     */
    manualInput(data, obj) {
        this.chooseInputInteraction(data, obj, 'focus');
        this.chooseInputInteraction(data, obj, 'blur');
        this.chooseInputInteraction(data, obj, 'keyup');
        this.chooseInputInteraction(data, obj, 'keydown');
    }

    /**
     * Определение поведения инпутов и слайдеров при взаимодействии с инпутами
     * @param {Object} data - все значения слайдера
     * @param {Object} obj - экземпляр HTB для текущего инпута
     * @param {String} interaction - тип взаимодействия с инпутом
     */
    chooseInputInteraction(data, obj, interaction) {
        const onlyNumbersRegexp = /[^0-9.]/g;
        const that = this;

        /* eslint-disable */
        data.input.addEventListener(interaction, function(event) {
            switch (interaction) {
                case 'focus':
                    U.useValue(this, '');
                    break;
                case 'blur':
                    if (U.useValue(this) === '') {
                        MortgageCalculator.setInput(data.from, data);
                    } else {
                        U.checkInputedData(this, data, onlyNumbersRegexp);
                        that.updateSlidersValues(data, 'set');
                        data.rangeSlider.ionRangeSliderInstance.update();
                        that.update();
                    }
                    break;
                case 'keyup':
                    if (U.useValue(this)) {
                        MortgageCalculator.setInput(Number(U.useValue(this)
                            .replace(onlyNumbersRegexp, '')), data);
                    }
                    break;
                case 'keydown':
                    U.preventNaNSymbolsEnter(event);
                    U.onKeyDownEvent(event, data, obj, this, onlyNumbersRegexp);
                    break;
                default:
                    console.error('Wrong type of interaction');
            }
        });
        /* eslint-enable */
    }

    /**
     * Расчитываем ежемесячных платёж по формуле:
     * @param {Number} rate - ставка
     * @return {Number} - ежемесячный платёж
     * A = K * S,
     * где A - ежемесечный аннуитетный платёж,
     * K - коэффициент аннуитета,
     * S - сумма кредита.
     * K = (i * (1 + n)^n) / (((1 + i)^n) - 1)
     * i - месячная процентная ставка по кредиту (годовая/12)
     * n - количетсво периодов, в течение которых выплачивается кредит
     */
    static calcMonthlyPay(rate) {
        const i = rate / 12 / 100;
        const n = U.accessStorage('limitation[min]') * 12;
        const kNumerator = i * Math.pow(1 + i, n);
        const kDenominator = Math.pow(1 + i, n) - 1;
        const _K = kNumerator / kDenominator;
        const _S = U.accessStorage('creditAmount');
        const _A = _K * _S;

        return _A < 0 ? '—' : _A;
    }

    /**
     * Высчитываем и устанавливаем ежемесячный платёж каждому банку
     */
    _setPaymentOnTable() {
        this.programs.forEach((item) => {
            this._calcPaymentForBank(item);
        });
    }

    _calcPaymentForBank(item) {
        const rate = Number(item.querySelector(this.programRateSelector).dataset.rate);

        item.querySelector(this.programMountlyPaymentSelector).innerHTML =
            U.isExist(MortgageCalculator.calcMonthlyPay(rate)) ?
                U.calc('monthlyPaymentPretty', MortgageCalculator.calcMonthlyPay(rate), null) :
                '—';
    }

    /**
     * Передаём список банков на проверку соответствия условиям
     * @private
     */
    _disableItems() {
        this.programs.forEach((item) => {
            this._setDisabled(item);
        });
    }

    /**
     * Отключаем банк, если он не подходит по параметрам
     * @param {Object} item - DOM элемент программы
     * @private
     */
    _setDisabled(item) {
        const monthlyPayment = item.querySelector(this.programMountlyPaymentSelector);

        const firstPaymentCell = item.querySelector(this.programFirstPaymentSelector);
        const firstPayment = Number(firstPaymentCell.dataset.firstPayment);
        const firstPaymentMax = Number(firstPaymentCell.dataset.firstPaymentMax);

        const limitationCell = item.querySelector(this.programLimitationSelector);
        const limitation = Number(limitationCell.dataset.limitation);
        const limitationMin = Number(limitationCell.dataset.limitationMin);

        const maxAvailableCredit = item.dataset.creditAmountMax ? Number(item.dataset.creditAmountMax) : null;

        const itemProgram = item.dataset.type;

        const creditPercentStorage = U.accessStorage('creditPercent');
        const limitationMinStorage = U.accessStorage('limitation[min]');
        const currentCreditStorage = U.accessStorage('creditAmount');

        if (creditPercentStorage < firstPayment || creditPercentStorage > firstPaymentMax ||
            limitationMinStorage > limitation || limitationMinStorage < limitationMin ||
            // Проверка на максимально допустимую сумму кредита, которую может выдать банк, если сумма есть
            (maxAvailableCredit && currentCreditStorage > maxAvailableCredit) ||
            (this.activeProgram && this.activeProgram !== itemProgram)) {
            monthlyPayment.innerHTML = '—';
            item.classList.add(this.disabledClass);
        } else {
            item.classList.remove(this.disabledClass);
        }
    }

    /**
     * Выводит плашку об отсутствии результатов
     * @private
     */
    _checkEmptyResult() {
        const noResult = Boolean(!this._activePrograms().length);

        if (noResult) {
            this.programResult.classList.add(this.hiddenClass);
            this.programNoResult.classList.remove(this.hiddenClass);
        } else {
            this.programResult.classList.remove(this.hiddenClass);
            this.programNoResult.classList.add(this.hiddenClass);
        }
    }

    /**
     * Передаём строки таблицы с банками на упорядочивание
     */
    _setOrder() {
        this.programs.forEach((item) => {
            this._setItemOrder(item);
        });
    }

    /**
     * Устанавливаем свойство order для каждого банка, чтобы упорядочить элементы по цене
     * @param {Object} obj - DOM элемент каждого банка (строка в таблице или карточка)
     * @private
     */
    _setItemOrder(obj) {
        const specialOrderCoefficient = 10000000;
        let payment = Number(obj.querySelector(this.programMountlyPaymentSelector)
            .innerHTML
            .replace(/[^0-9]/g, ''));

        obj.setAttribute('data-payment', payment === 0 ? specialOrderCoefficient : payment);

        if (obj.dataset.sort && !obj.classList.contains(this.disabledClass)) {
            payment = Number(obj.dataset.sort);
        }

        obj.style.order = payment === 0 ? specialOrderCoefficient : payment;
    }

    /**
     * Функция обновления значений ипотечной таблицы, карточек и количества предложений
     */
    update() {
        this._setPaymentOnTable();
        this._disableItems();
        this._checkEmptyResult();
        this._setOrder();
    }

    setShareParam(setHash = true) {
        const query = new URLSearchParams();
        const hash = window.location.hash;
        const searchParams = new URLSearchParams(window.location.search);

        // Проверяем нет ли уникальной планировки у квартиры, если есть, то ставим ее
        if (searchParams.has('type')) {
            query.append('type', searchParams.get('type'));
        }

        query.append('first-pay[min]', U.accessStorage('first-pay[min]'));
        query.append('limitation[min]', U.accessStorage('limitation[min]'));

        if (setHash) {
            window.history.pushState(null, null, `?${query.toString()}${hash}`);
        }
    }

    _activePrograms() {
        return this.programs.filter((program) => {
            return !program.classList.contains('is-disabled');
        });
    }
}

export default MortgageCalculator;
